import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "l-main" }
const _hoisted_2 = { class: "l-error c-card" }
const _hoisted_3 = { class: "l-error__inner-red" }
const _hoisted_4 = { class: "l-error__message l-error__message--red" }
const _hoisted_5 = { class: "l-error__btn" }
const _hoisted_6 = { class: "c-buttonWrap4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconAlert = _resolveComponent("IconAlert")!
  const _component_ButtonLink = _resolveComponent("ButtonLink")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", null, [
            _createVNode(_component_IconAlert)
          ]),
          _cache[0] || (_cache[0] = _createElementVNode("p", null, " お使いのアカウントはご利用いただけません。 ", -1))
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_ButtonLink, {
              tag: "a",
              href: _ctx.redirectUrl,
              "style-type": "primary",
              color: "color2"
            }, {
              default: _withCtx(() => _cache[1] || (_cache[1] = [
                _createTextVNode(" ログイン ", -1)
              ])),
              _: 1,
              __: [1]
            }, 8, ["href"])
          ])
        ])
      ])
    ])
  ]))
}